import React, {Component} from "react";
import {Nav, Navbar} from "react-bootstrap";
import {GetUser} from "./helpers/User";

export default class CustomNavbar extends Component {
    state ={}
    componentDidMount() {
        GetUser().then(user =>{
            this.setState({user:user});
        })
    }

    render() {
        return <Navbar expand="lg">
            <Navbar.Brand><div className={"circle-logo"}/> Telos</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                </Nav>
                {this.state.user ?
                    <Nav>
                        <Nav.Link href={"/campaigns"}>Campaigns</Nav.Link>
                        <Nav.Link href={"/users/account"} className={"account-btn"}>
                            {this.state.user.firstName && this.state.user.firstName.length ? this.state.user.firstName[0] : ""}
                            {this.state.user.lastName && this.state.user.lastName.length ? this.state.user.lastName[0]:""}
                        </Nav.Link>
                        {/*    TODO: Drop down with picture or initials, log out, edit profile*/}
                    </Nav> : <Nav>
                        <Nav.Link href={"/sign-in"}>Login</Nav.Link>
                        <Nav.Link href={"/sign-in"}>Sign Up</Nav.Link>
                        {/*https://react-bootstrap.github.io/components/navbar/*/}
                    </Nav>
                }
            </Navbar.Collapse>
        </Navbar>
    }
}
